import React, { useEffect, useRef, useState } from 'react';
import omit from 'lodash/omit';

// Components
import Carousel from 'app/shared/components/Carousel';

import * as S from './styles';
import getTiles from './Items';
import optimizelyUtils from 'app/shared/utils/analytics/optimizelyUtils';

import type { CardProps, SpacingMixinProps } from '@zillow/constellation';
import type { PMR_CATEGORY, RMP_CATEGORY } from 'app/shared/constants/AnalyticsConstants';

interface UpsellCarouselModuleProps {
  gaTrackingCategory: typeof PMR_CATEGORY | typeof RMP_CATEGORY;
}

const UpsellCarouselModule: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<UpsellCarouselModuleProps & CardProps & SpacingMixinProps>>
> = (props) => {
  const { gaTrackingCategory } = props;
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);
  const rest = omit(props, ['gaTrackingCategory']);
  const AUTO_SCROLL_SPEED = 10 * 1000;
  const AUTO_SCROLL_PAUSE_DURATION = 30 * 1000;

  const updateWidth = () => {
    const containerObj = (containerRef && containerRef.current) || {
      offsetWidth: 1220,
    };

    setWidth(containerObj.offsetWidth);
  };

  useEffect(() => {
    optimizelyUtils.initiate();

    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  const ZrmUpsellItems = getTiles(gaTrackingCategory);

  return (
    <S.Container cardType="secondary" ref={containerRef} {...rest}>
      <Carousel
        width={width}
        items={ZrmUpsellItems}
        autoScrollSpeed={AUTO_SCROLL_SPEED}
        autoScrollPauseDuration={AUTO_SCROLL_PAUSE_DURATION}
      />
    </S.Container>
  );
};

export default UpsellCarouselModule;
